<template>
  <div>
    <!-- 工具栏 -->
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>

        <el-select style="padding-left: 20px" v-model="curAuditStatus" @change="onCurAuditStatusChange" clearable>
          <el-option v-for="item in auditStatusOptions" :value="item" :key="item"
                     :label="item | appReportAuditStatusTransform"></el-option>
        </el-select>

      </div>
    </div>

    <el-table ref="tableRef" v-loading="loading" :data="tableData" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }" @expand-change="expandChange" :row-key="getRowKey"
              :expand-row-keys="expandedRow"

    ><!--              @row-click="rowClick"-->
      <el-table-column type="expand">
        <template #default="scope">
          <el-table v-if="scope.row.appReportFileList.length > 0" :data="scope.row.appReportFileList">
            <el-table-column label="#" prop="appReportFileId"></el-table-column>
            <el-table-column label="文件" prop="">
              <template #default="scope">
                <div style="width: 100px; height: 100px;position: relative">
                  <el-image style="width: 100px; height: 100px;" fit="scale-down"
                            @click="previewImage(scope.row)"
                            :src="getImageUrl(scope.row)" lazy :preview-src-list="[getImageUrl(scope.row)]"
                            :close-on-click-modal="true">
                    <template #error>
                      <p></p>
                    </template>
                  </el-image>
                  <i class="el-icon-video-play"
                     v-if="scope.row.fileType === 1"
                     style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: black;"
                     @click.stop="previewVideo(scope.row.fileUrl)"></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <p v-else>没有补充图像数据</p>
        </template>
      </el-table-column>
      <el-table-column prop="appReportId" label="#" align="center"></el-table-column>
      <el-table-column prop="categoryName" label="举报原因" align="center"></el-table-column>
      <el-table-column prop="resourceId" label="举报资源" align="center" show-overflow-tooltip>
        <template #default="scope">
          {{ getResourceDesp(scope.row) }}
        </template>
      </el-table-column>
      <!--      <el-table-column prop="resourceObj.fileName" label="举报资源连接" align="center"></el-table-column>-->

      <el-table-column prop="objectType" label="举报资源类型" align="center">
        <template #default="scope">
          {{ scope.row.objectType | appReportObjectTypeTransform }}
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="举报时间" align="center">
        <template #default="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column prop="auditStatus" label="处理状态" align="center">
        <template #default="scope">
          {{ scope.row.auditStatus | appReportAuditStatusTransform }}
        </template>
      </el-table-column>
      <el-table-column prop="auditTime" label="处理时间" align="center">
        <template #default="scope">
          {{ scope.row.auditTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="被举报人" align="center">
        <template #default="scope">
          {{ scope.row.objectNickname }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="reason" label="详细原因"></el-table-column>
      <el-table-column prop="deleteTime" label="删除时间" align="center">
        <template #default="scope">
          {{ scope.row.deleteTime | formatDateTime }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="250">
        <template #default="scope">
          <el-button size="small" type="primary" @click.stop="handlePreviewResource(scope.row)"
                     :disabled="previewResourceDisable(scope.row)">查看
          </el-button>
          <el-button size="small" type="primary" @click.stop="handleAuditAppReport(scope.row)">审核</el-button>
          <el-button size="small" @click.stop="handleDeleteAppReport(scope.row)"
                     :type="scope.row.deleted ? 'warning' : 'danger'">
            {{ scope.row.deleted ? '恢复' : '删除' }}
          </el-button>
        </template>

      </el-table-column>
    </el-table>
    <el-pagination background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.currentPage" @current-change="curPageChange"/>
    <!--  审核  -->
    <el-dialog title="审核" :visible.sync="auditAppReportDialog">
      <el-form ref="form" :model="auditAppReportForm" label-width="80px">
        <el-form-item label="处理进度" required>
          <el-radio-group v-model="auditAppReportForm.auditStatus">
            <el-radio v-for="item in auditStatusOptions" :key="item"
                      :label="item">{{ item | appReportAuditStatusTransform }}
            </el-radio>
          </el-radio-group>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click.stop="auditAppReportDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click.stop="() => submitAudit()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 预览视频 -->
    <el-dialog title="查看视频" :visible.sync="previewVideoDialog" width="60%" :destroy-on-close='true'>
      <tx-video-player style="height: 60vh" :videoUrl="previewVideoPath"></tx-video-player>
    </el-dialog>

  </div>
</template>

<script>
import {
  getAppReportList,
  appReportDeleteOrBack,
  auditAppReport
} from "@/api/AppReport/AppReport";
import {handleRes} from "@/utils/handleRes";
import {isVaild} from "@/utils/validate";
import {deepClone} from "@/utils";
import {getCloudUrl, getPreviewImgUrl} from "@/utils/urlutil";
import txVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import {go2LiveDetail, go2LiveReviewDetail, go2LiveVideoDetail, go2UltrasonicDetail} from "@/utils/UIHelper";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  name: "AppReportList",
  components: {
    txVideoPlayer
  },
  data() {
    return {
      navigationKey: "AppReportList",

      loading: false, // 加载开关
      tableData: [], // 传值给子组件mytable
      // 分页配置
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      searchValue: "",
      curAuditStatus: "",
      auditStatusOptions: [0, 1, 2],
      auditAppReportDialog: false,
      auditAppReportForm: {},

      previewImagePath: "",
      previewImageDlg: false,
      previewVideoPath: "",
      previewVideoDialog: false,

      expandedRow: [],
    }
  },
  methods: {
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.currentPage = 1
      this.getAppReportList()
    },
    curPageChange(curPage) {
      this.pageOpt.currentPage = curPage
      this.getAppReportList()
    },
    onCurAuditStatusChange() {
      this.refreshList()
    },
    getAppReportList() {
      this.loading = true;
      let params = {
        sortName: "",
        sortOrder: "",
        pageIndex: this.pageOpt.currentPage,
        pageSize: this.pageOpt.pageSize,
        keyWord: this.searchValue,
      }
      if (isVaild(this.curAuditStatus)) {
        params.where = [{
          "field": "auditStatus",
          "value": this.curAuditStatus,
          "op": "equal"
        }]
      }

      setNavigationItemWithObj(this.navigationKey, {
        currentPage: this.pageOpt.currentPage,
        searchValue: this.searchValue,
        curAuditStatus: this.curAuditStatus
      })

      getAppReportList(params).then(res => {
        handleRes(res, () => {
          this.pageOpt.totalCount = res.data.total
          this.tableData = res.data.rows
        })
        this.utils.stopLoading(this)
      })
    },
    handleDeleteAppReport(entity) {
      appReportDeleteOrBack({
        appReportId: entity.appReportId
      }).then(res => {
        handleRes(res, () => {
          this.getAppReportList()
        })
      })
    },
    /**
     * 根据objectType ， 获取举报资源的ID
     * 0- userID
     * 1-forumID
     * 2-forumCommentID
     * 3-forumGroupID
     * 4-videoID
     * 5–videoCommentID
     * 6-liveID(往期回顾视频id)
     * 7-liveCommentID
     * 8-problemID
     * 9-problenAnswerID
     * 10-answerCommentID
     * 11-liveID（直播id）
     * 12-liveChatRecordID
     * 13-csFileID
     * @param entity
     */
    getResourceDesp(entity) {
      switch (entity.objectType) {
        case 0://用户
          return `${entity.resourceObj.nickname}(id:${entity.resourceObj.userID})`
        case 1://超人圈帖子
          return `${entity.resourceObj.customTitle}(id:${entity.resourceObj.forumId})`
        case 2://超人圈帖子评论
          return `${entity.resourceObj.content}(id:${entity.resourceObj.forumCommentId})`
        case 3://超人圈圈子
          return `${entity.resourceObj.groupName}(id:${entity.resourceObj.forumGroupId})`
        case 4://视频案例
          return `${entity.resourceObj.videoName}(id:${entity.resourceObj.videoID})`
        case 5://视频案例评论
          return `${entity.resourceObj.content}(id:${entity.resourceObj.videoCommentID})`
        case 6://往期回顾视频
          return `${entity.resourceObj.liveTitle}(id:${entity.resourceObj.liveId})`
        case 7://往期回顾视频评论
          return `${entity.resourceObj.content}(id:${entity.resourceObj.liveCommentId})`
        case 8://问答问题
          return `${entity.resourceObj.title}(id:${entity.resourceObj.problemId})`
        case 9://问答答案
          return `${entity.resourceObj.content}(id:${entity.resourceObj.problemAnswerId})`
        case 10://问答答案评论
          return `${entity.resourceObj.content}(id:${entity.resourceObj.answerCommentID})`
        case 11://直播/会议
          return `${entity.resourceObj.liveTitle}(id:${entity.resourceObj.liveId})`
        case 12://直播间聊天信息
          return `${entity.resourceObj.chatContent}(id:${entity.resourceObj.liveChatRecordsId})`
        case 13://客服文件
          return `${entity.resourceObj.fileShowName}(id:${entity.resourceObj.csFileID})`
        case 14://圈子文件
          return `${entity.resourceObj.fileName}(id:${entity.resourceObj.forumGroupFileId})`
      }
      return "-"
    },
    handleAuditAppReport(entity) {
      this.auditAppReportForm = deepClone(entity)
      this.auditAppReportDialog = true
    },
    async submitAudit() {
      let data = {
        appReportId: this.auditAppReportForm.appReportId,
        status: this.auditAppReportForm.auditStatus
      }
      auditAppReport(data).then(res => {
        this.auditAppReportDialog = false
        handleRes(res, () => {
          this.getAppReportList()
        })
      })

    },
    previewImage(entity) {
      this.previewImagePath = this.getImageUrl(entity)
      this.previewImageDlg = true
    },
    previewVideo(fileUrl) {
      this.previewVideoPath = getCloudUrl(fileUrl)
      this.previewVideoDialog = true
    },
    getImageUrl(entity) {
      return getPreviewImgUrl(entity)
    },
    previewResourceDisable(entity) {
      return [
        // 7,//往期回顾视频评论
        // 10,//问答答案评论
      ].indexOf(entity.objectType) >= 0
    },
    handlePreviewResource(entity) {
      switch (entity.objectType) {
        case 0://用户
          this.$router.push({
            path: "/cloud_system_page/userDetail",
            query: {
              userID: entity.resourceObj.userID,
            },
          })
          break
        case 1://超人圈帖子
        case 2://超人圈帖子评论
          go2UltrasonicDetail(this, entity.resourceObj.forumId)
          break
        case 3://超人圈圈子
        case 14://圈子文件
          this.$router.push({
            path: "/cloud_maili_page/ultrasonicGroupsDetail",
            query: {
              ForumGroupID: entity.resourceObj.forumGroupId,
              part: 2,
              judgeCreator: false,
            },
          });
          break
        case 4://视频案例
        case 5://视频案例评论
          go2LiveVideoDetail(this, entity.resourceObj.videoID)
          break
        case 6://往期回顾视频
        case 7://往期回顾视频评论
          // this.$router.push({
          //   path: "/mai/liveReview",
          //   query: {
          //     reviewListSearchValue: entity.resourceObj.liveTitle
          //   },
          // });
          go2LiveReviewDetail(this, entity.resourceObj.liveId)
          break
        case 8://问答问题
        case 9://问答答案
          this.$router.push({
            path: "/cloud_system_page/quizDetail",
            query: {
              problemId: entity.resourceObj.problemId,
            },
          });
          break
        case 10://问答答案评论
          this.$router.push({
            path: "/cloud_system_page/quizAnswerReply",
            query: {
              problemAnswerId: entity.resourceObj.problemAnswerID,
            },
          })
          break;
        case 11://直播/会议
          go2LiveDetail(this, entity.resourceObj.liveTitle)
          break
        case 12://直播间聊天信息
          this.$router.push({
            path: "/cloud_system_page/liveInfo",
            query: {
              liveID: entity.resourceObj.liveId,
              tabName: 'chatRecord'
            },
          });
          break
        case 13://客服文件
          this.$router.push({
            path: "/cloud_system_page/cs_document_page/file",
            query: {
              fileSearchValue: entity.resourceObj.fileShowName,
            },
          });
          break
      }
    },
    /*
    ========================== table expand相关
     */
    /**
     * table的展开改变回调
     * @param {Object} row
     * @param {Object} expandedRows
     */
    expandChange(row, expandedRows) {
      if (this.expandedRow.indexOf(row.appReportId) >= 0) {
        this.expandedRow = []
      } else {
        this.expandedRow = [row.appReportId]
      }

    },
    rowClick(row) {
      this.$refs.tableRef.toggleRowExpansion(row)
    },
    /**
     * 返回table的row key
     * @param {Object} row
     */
    getRowKey(row) {
      return row.appReportId
    },
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.pageOpt.currentPage = navigationObj.currentPage
    this.curAuditStatus = navigationObj.curAuditStatus
    this.searchValue = navigationObj.searchValue

    this.getAppReportList()
  }
}
</script>

<style scoped>

</style>